import { createSlice } from "@reduxjs/toolkit";

export const account = createSlice({
  name: "account",
  initialState: {
    value: {
      cnpj: false,
      fullName: false,
      email: false,
      phone: false,
      id: false,
      numberOfVisits: false,
      lastVisitDate: false
    },
  },
  reducers: {
    //TODO criar metodo set
    setAccount(state, { payload }) {
      state.value.cnpj = payload.cnpj;
      state.value.fullName = payload.fullName;
      state.value.id = payload.id;
      state.value.email = payload.email
      state.value.phone = payload?.phone
      console.log(state.value.fullName)
      state.value.phone = payload.phone
      state.value.numberOfVisits = payload.numberOfVisits
      state.value.lastVisitDate = payload.lastVisitDate
    },
    resetAccount(state, {payload}) {
      state.value.cnpj = false;
      state.value.fullName = false;
      state.value.email = false
      state.value.phone = false
      state.value.numberOfVisits = false
      state.value.lastVisitDate = false
    }
  },
});

export const { setAccount, resetAccount } = account.actions;
export default account.reducer;
